module.exports = __webpack_public_path__ + "static/media/AC6.61840892.png";